import { AuthQueryKeys } from "@/configs/common"
import { CustomUseQueryOptions } from "@/types/common"
import { getNonceApi } from "@/services/auth"
import { useQuery } from "@tanstack/react-query"

interface UseGetNonceProps extends CustomUseQueryOptions {
  address?: string
}

export const useGetNonce = ({ address, ...props }: UseGetNonceProps) => {
  const getNonce = async () => {
    if (!address) return null
    return await getNonceApi(address)
  }

  return useQuery({
    queryKey: [AuthQueryKeys.NONCE, address],
    queryFn: getNonce,
    enabled: !!address,
    ...props,
  })
}
